import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import {
  FaEnvelope,
  FaLock,
  FaSignInAlt,
  FaEye,
  FaEyeSlash
} from 'react-icons/fa';
// import service
import { adminLogin } from '../services/authService';
import './Auth.css';

const Login = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });

    setError('');
  };

  // LOGIN API FUNCTION
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      setError('');

      // API CALL
      const response = await adminLogin(formData);

      /*
        Expected API Response:
        {
          status: true,
          token: "...",
          user: {
            name: "Admin",
            email: "admin@gmail.com"
          }
        }
      */

      // SAVE TOKEN
      localStorage.setItem('token', response.token);

      // SAVE USER
      localStorage.setItem(
        'user',
        JSON.stringify(response.user)
      );

      // REDIRECT
      navigate('/dashboard');

    } catch (err) {
      setError(
        err.message || 'Invalid email or password'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-wrapper">
      <div className="auth-container">
        <div className="auth-card">

          <div className="auth-header">
            <div className="auth-logo">
              <FaSignInAlt />
            </div>

            <h2>Welcome Back!</h2>
            <p>Sign in to your admin account</p>
          </div>

          <form onSubmit={handleSubmit} className="auth-form">

            {error && (
              <div className="alert alert-danger">
                {error}
              </div>
            )}

            {/* EMAIL */}
            <div className="form-group">
              <label>Email Address</label>

              <div className="input-group">
                <span className="input-icon">
                  <FaEnvelope />
                </span>

                <input
                  type="email"
                  name="email"
                  className="form-control"
                  placeholder="admin@example.com"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            {/* PASSWORD */}
            <div className="form-group">
              <label>Password</label>

              <div className="input-group">
                <span className="input-icon">
                  <FaLock />
                </span>

                <input
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  className="form-control"
                  placeholder="Enter your password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                />

                <button
                  type="button"
                  className="password-toggle"
                  onClick={() =>
                    setShowPassword(!showPassword)
                  }
                >
                  {showPassword ? (
                    <FaEyeSlash />
                  ) : (
                    <FaEye />
                  )}
                </button>
              </div>
            </div>

            <div className="form-options">
              <label className="checkbox-label">
                <input type="checkbox" />
                <span>Remember me</span>
              </label>

              <a href="#" className="forgot-link">
                Forgot Password?
              </a>
            </div>

            <button
              type="submit"
              className="btn btn-primary btn-block"
              disabled={loading}
            >
              {loading
                ? 'Signing in...'
                : 'Sign In'}
            </button>

          </form>

          <div className="auth-footer">
            <p>
              Don't have an account?
              <Link to="/register">
                Create Account
              </Link>
            </p>
          </div>

        </div>
      </div>

      <div className="auth-bg">
        <div className="bg-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
        </div>
      </div>
    </div>
  );
};

export default Login;